import { type FC } from 'react';
import {
  Folders
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconFoldersProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconFolders: FC<UiIconFoldersProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Folders}
      {...props}
    />
  );
};
